// src/components/membership/InvoiceDownloadButton.jsx
import React, { useState } from 'react';
import { toast } from 'react-toastify';
import axios from 'axios';
// import api from '../../utils/api';
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 5000,
});

const InvoiceDownload = ({ transactionId }) => {
  const [downloading, setDownloading] = useState(false);

  const handleDownload = async () => {
    try {
      const token = localStorage.getItem('ownerToken');

      setDownloading(true);
      const response = await api.get(
        `/subscriptions/invoices/${transactionId}`,
        {
          responseType: 'blob',
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      // Create blob link and download
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `invoice-${transactionId}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      toast.error('Failed to download invoice');
    } finally {
      setDownloading(false);
    }
  };

  return (
    <button
      onClick={handleDownload}
      disabled={downloading}
      className='text-blue-500 hover:text-blue-700 disabled:opacity-50'
    >
      {downloading ? 'Downloading...' : 'Download Invoice'}
    </button>
  );
};

export default InvoiceDownload;

// import React, { useState, useEffect } from 'react';
// import { useLocation, useNavigate } from 'react-router-dom';
// // import { loadStripe } from '@stripe/stripe-js';
// // import {
// //   Elements,
// //   PaymentElement,
// //   useStripe,
// //   useElements,
// // } from '@stripe/react-stripe-js';
// import { toast } from 'react-toastify';

// // import { formatCurrency } from '../../utils/currency';
// import axios from 'axios';
// const api = axios.create({
//   baseURL: process.env.REACT_APP_API_URL,
//   timeout: 5000,
// });

// // src/components/membership/InvoiceDownload.jsx
// const InvoiceDownload = ({ transactionId }) => {
//   const handleDownload = async () => {
//     try {
//       const response = await api.get(
//         `/subscriptions/invoices/${transactionId}`,
//         {
//           responseType: 'blob',
//         }
//       );

//       // Create blob link to download
//       const url = window.URL.createObjectURL(new Blob([response.data]));
//       const link = document.createElement('a');
//       link.href = url;
//       link.setAttribute('download', `invoice-${transactionId}.pdf`);

//       // Append to html page
//       document.body.appendChild(link);
//       link.click();

//       // Clean up and remove the link
//       link.parentNode.removeChild(link);
//     } catch (error) {
//       toast.error('Failed to download invoice');
//     }
//   };

//   return (
//     <button
//       onClick={handleDownload}
//       className='text-blue-500 hover:text-blue-700'
//     >
//       Download Invoice
//     </button>
//   );
// };
// export default InvoiceDownload;

// // Update the transaction history part in your MembershipInfo component
// <div className='overflow-x-auto'>
//   <table className='min-w-full'>
//     <thead>
//       <tr className='bg-gray-50'>
//         <th className='px-6 py-3 text-left text-gray-500 font-medium'>Date</th>
//         <th className='px-6 py-3 text-left text-gray-500 font-medium'>
//           Description
//         </th>
//         <th className='px-6 py-3 text-left text-gray-500 font-medium'>
//           Amount
//         </th>
//         <th className='px-6 py-3 text-left text-gray-500 font-medium'>
//           Status
//         </th>
//         <th className='px-6 py-3 text-left text-gray-500 font-medium'>
//           Actions
//         </th>
//       </tr>
//     </thead>
//     <tbody>
//       {transactions.map((transaction) => (
//         <tr key={transaction.id} className='border-t hover:bg-gray-50'>
//           <td className='px-6 py-4'>
//             {format(new Date(transaction.date), 'MMM dd, yyyy')}
//           </td>
//           <td className='px-6 py-4'>
//             {transaction.description}
//             {transaction.type === 'downgrade' && (
//               <span className='ml-2 text-orange-500'>
//                 (Changes effective{' '}
//                 {format(new Date(transaction.effectiveDate), 'MMM dd, yyyy')})
//               </span>
//             )}
//           </td>
//           <td className='px-6 py-4'>
//             ${(transaction.amount / 100).toFixed(2)}
//           </td>
//           <td className='px-6 py-4'>
//             <span
//               className={`px-2 py-1 rounded-full text-sm ${
//                 transaction.status === 'completed'
//                   ? 'bg-green-100 text-green-800'
//                   : 'bg-red-100 text-red-800'
//               }`}
//             >
//               {transaction.status}
//             </span>
//           </td>
//           <td className='px-6 py-4'>
//             <InvoiceDownload transactionId={transaction.id} />
//           </td>
//         </tr>
//       ))}
//     </tbody>
//   </table>
// </div>;
